import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import App from './App'
import { BrowserRouter, NavLink, Route } from 'react-router-dom'
import { create as createStyleGuide } from 'react-easy-styleguide'
import './index.css'
import './design.info'

const styleguideContext = require.context('./components/', true, /.info.js/)

ReactDOM.render(
  <BrowserRouter>
    <Route path="/" component={App} exact />
    <Route
      path="/react-easy-styleguide/:component?/:variation?"
      component={
        createStyleGuide(styleguideContext, {
          name: 'My Styleguide',
          propTypes: PropTypes,
          routerLink: NavLink,
          path: '/react-easy-styleguide/',
        }) as any
      }
    />
  </BrowserRouter>,
  document.getElementById('root'),
)
